<template>
  <div style="background: #ececec; padding: 10px">
    <a-row :gutter="16">
      <a-col :span="6">
        <a-card>
          <div v-if="loading" style="height:64px;" class="d-flex flex-column justify-space-between">
            <span class="text-gray">订单总金额(万元)</span>
            <LoadingOutlined style="text-align: left;" />
          </div>
          <a-statistic v-else :title="`订单总金额(${order_unit})`" :value="order_amount" :precision="2"
            :value-style="{ color: '#3f8600' }">
          </a-statistic>
        </a-card>
      </a-col>
      <a-col :span="6">
        <a-card>
          <div v-if="loading" style="height:64px;" class="d-flex flex-column justify-space-between">
            <span class="text-gray">回款总金额(万元)</span>
            <LoadingOutlined style="text-align: left;" />
          </div>
          <a-statistic v-else :title="`回款总金额(${trade_unit})`" :value="trade_amount" :precision="2"
            :value-style="{ color: '#cf1322' }">
          </a-statistic>
        </a-card>
      </a-col>
      <a-col :span="6">
        <a-card>
          <div v-if="loading" style="height:64px;" class="d-flex flex-column justify-space-between">
            <span class="text-gray">采购总金额(万元)</span>
            <LoadingOutlined style="text-align: left;" />
          </div>
          <a-statistic v-else :title="`采购总金额(${purchase_unit})`" :value="purchase_amount" :precision="2"
            :value-style="{ color: '#3f8600' }">
          </a-statistic>
        </a-card>
      </a-col>
      <a-col :span="6">
        <a-card>
          <div v-if="loading" style="height:64px;" class="d-flex flex-column justify-space-between">
            <span class="text-gray">物流总金额(万元)</span>
            <LoadingOutlined style="text-align: left;" />
          </div>
          <a-statistic v-else :title="`物流总金额(${logistics_unit})`" :value="logistics_amount" :precision="2"
            :value-style="{ color: '#cf1322' }">
          </a-statistic>
        </a-card>
      </a-col>
    </a-row>
    <a-row :gutter="16">
      <a-col :span="6">
        <a-card>
          <div v-if="loading" style="height:64px;" class="d-flex flex-column justify-space-between">
            <span class="text-gray">授信额度(万元)</span>
            <LoadingOutlined style="text-align: left;" />
          </div>
          <a-statistic v-else :title="`授信额度(${credit_unit})`" :value="credit_amount" :precision="2"
            :value-style="{ color: '#3f8600' }" style="margin-right: 50px">
          </a-statistic>
        </a-card>
      </a-col>
      <a-col :span="6">
        <a-card>
          <div v-if="loading" style="height:64px;" class="d-flex flex-column justify-space-between">
            <span class="text-gray">已放款(万元)</span>
            <LoadingOutlined style="text-align: left;" />
          </div>
          <a-statistic v-else :title="`已放款(${loan_paid_unit})`" :value="loan_paid_amount" :precision="2"
            :value-style="{ color: '#3f8600' }">
          </a-statistic>
        </a-card>
      </a-col>
      <a-col :span="6">
        <a-card>
          <div v-if="loading" style="height:64px;" class="d-flex flex-column justify-space-between">
            <span class="text-gray">待放款(万元)</span>
            <LoadingOutlined style="text-align: left;" />
          </div>
          <a-statistic v-else :title="`待放款(${loan_unpaid_unit})`" :value="loan_unpaid_amount" :precision="2"
            :value-style="{ color: '#cf1322' }">
          </a-statistic>
        </a-card>
      </a-col>
      <a-col :span="6">
        <a-card>
          <div v-if="loading" style="height:64px;" class="d-flex flex-column justify-space-between">
            <span class="text-gray">待审核(万元)</span>
            <LoadingOutlined style="text-align: left;" />
          </div>
          <a-statistic v-else :title="`待审核(${loan_verify_unit})`" :value="loan_verify_amount" :precision="2"
            :value-style="{ color: '#cf1322' }">
          </a-statistic>
        </a-card>
      </a-col>
    </a-row>
  </div>
  <a-spin :spinning="data_loading">
    <a-tabs v-model:activeKey="data_type" @change="(v) => getchartdata(v, date_type)">
      <a-tab-pane key="order" tab="销售订单统计">
        <div class="content sale">
          <a-card title="销售额" :bordered="false" style="width: 100%">
            <v-chart class="chart" :option="orderOption1" autoresize style="width:100%; height:348px;" />
          </a-card>
          <a-card title="订单数" :bordered="false" style="width: 100%">
            <v-chart class="chart" :option="orderOption2" autoresize style="width:100%; height:348px;" />
          </a-card>
          <!-- <a-card title="总成本｜总利润" :bordered="false" style="width: 100%">
            <v-chart class="chart" :option="barOption" autoresize style="width:100%; height:348px;" />
          </a-card> -->
        </div>
      </a-tab-pane>
      <a-tab-pane key="trade" tab="回款明细统计">
        <div class="content trade">
          <a-card title="交易金额" :bordered="false" style="width: 100%">
            <v-chart class="chart" :option="tradeOption1" autoresize style="width:100%; height:348px;" />
          </a-card>
          <a-card title="订单数" :bordered="false" style="width: 100%">
            <v-chart class="chart" :option="tradeOption2" autoresize style="width:100%; height:348px;" />
          </a-card>
        </div>
      </a-tab-pane>
      <a-tab-pane key="purchase" tab="采购订单统计">
        <div class="content purchase">
          <a-card title="采购金额" :bordered="false" style="width: 100%">
            <v-chart class="chart" :option="purchaseOption1" autoresize style="width:100%; height:348px;" />
          </a-card>
          <a-card title="订单数" :bordered="false" style="width: 100%">
            <v-chart class="chart" :option="purchaseOption2" autoresize style="width:100%; height:348px;" />
          </a-card>
        </div>
      </a-tab-pane>
      <!-- <a-tab-pane key="logistics" tab="物流单统计">
        <div class="content purchase">
          <a-card title="物流金额" :bordered="false" style="width: 100%">
            <v-chart class="chart" :option="logisticsOption1" autoresize style="width:100%; height:348px;" />
          </a-card>
          <a-card title="订单数" :bordered="false" style="width: 100%">
            <v-chart class="chart" :option="logisticsOption2" autoresize style="width:100%; height:348px;" />
          </a-card>
        </div>
      </a-tab-pane> -->
      <!-- <a-tab-pane key="inventory" tab="库存SKU数据统计">
        <div class="content purchase">
          <a-card title="库存金额" :bordered="false" style="width: 100%">
            <v-chart class="chart" :option="inventoryOption1" autoresize style="width:100%; height:348px;" />
          </a-card>
          <a-card title="库存SKU数" :bordered="false" style="width: 100%">
            <v-chart class="chart" :option="inventoryOption2" autoresize style="width:100%; height:348px;" />
          </a-card>
        </div>
      </a-tab-pane> -->
      <!-- <a-tab-pane key="org" tab="商户数据统计">
        <div class="content purchase">
          <a-card title="订单销售情况" :bordered="false" style="width: 100%">
            <v-chart class="chart" :option="lineOption" autoresize style="width:100%; height:348px;" />
          </a-card>
          <a-card title="采购情况" :bordered="false" style="width: 100%">
            <v-chart class="chart" :option="lineOption" autoresize style="width:100%; height:348px;" />
          </a-card>
          <a-card title="回款情况" :bordered="false" style="width: 100%">
            <v-chart class="chart" :option="lineOption" autoresize style="width:100%; height:348px;" />
          </a-card>
        </div>
      </a-tab-pane> -->
      <template #rightExtra>
        <a-radio-group v-model:value="date_type" @change="(e) => getchartdata(data_type, e.target.value)">
          <a-radio-button v-for="(item, index) in date_types" :key="index" :value="item.value">
            {{ item.label }}
          </a-radio-button>
        </a-radio-group>
      </template>
    </a-tabs>
  </a-spin>
</template>
<script setup>
import { LoadingOutlined } from "@ant-design/icons-vue";
import { ref, onActivated, getCurrentInstance, } from "vue";
import { message } from "ant-design-vue";
import _ from "underscore";

const { proxy } = getCurrentInstance();

const loading = ref(false);
//订单总金额
const order_amount = ref(0);
const order_unit = ref('万元');
//回款总金额
const trade_amount = ref(0);
const trade_unit = ref('万元');
//采购总金额
const purchase_amount = ref(0);
const purchase_unit = ref('万元');
//物流总金额
const logistics_amount = ref(0);
const logistics_unit = ref('万元');
//授信额度
const credit_amount = ref(0);
const credit_unit = ref('万元');
//已放款
const loan_paid_amount = ref(0);
const loan_paid_unit = ref('万元');
//待放款
const loan_unpaid_amount = ref(0);
const loan_unpaid_unit = ref('万元');
//待审核
const loan_verify_amount = ref(0);
const loan_verify_unit = ref('万元');
//统计维度
const data_type = ref('order');
const data_loading = ref(false);
const date_types = ref([
  { label: '近一月', value: 1 },
  { label: '近三月', value: 3 },
  { label: '近六月', value: 6 },
  { label: '近一年', value: 12 },
]);
const date_type = ref(1);
//销售订单统计

const generateLineOption = (list = []) => {
  return {
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'cross', crossStyle: { color: '#999' } }
    },
    xAxis: { type: 'category', data: _.pluck(list, "label"), },
    yAxis: { type: 'value' },
    series: [
      { data: _.pluck(list, 'value'), type: 'line', smooth: true }
    ]
  };
}

const orderOption1 = ref(generateLineOption());
const orderOption2 = ref(generateLineOption());
const tradeOption1 = ref(generateLineOption());
const tradeOption2 = ref(generateLineOption());
const purchaseOption1 = ref(generateLineOption());
const purchaseOption2 = ref(generateLineOption());
const logisticsOption1 = ref(generateLineOption());
const logisticsOption2 = ref(generateLineOption());
const inventoryOption1 = ref(generateLineOption());
const inventoryOption2 = ref(generateLineOption());
const lineOption = ref(generateLineOption());
const barOption = ref({
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'cross',
      crossStyle: {
        color: '#999'
      }
    }
  },
  // toolbox: {
  //   feature: {
  //     dataView: { show: true, readOnly: false },
  //     magicType: { show: true, type: ['line', 'bar'] },
  //     restore: { show: true },
  //     saveAsImage: { show: true }
  //   }
  // },
  legend: {
    data: ['Evaporation', 'Precipitation', 'Temperature']
  },
  xAxis: [
    {
      type: 'category',
      data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      axisPointer: {
        type: 'shadow'
      }
    }
  ],
  yAxis: [
    {
      type: 'value',
      name: 'Precipitation',
      min: 0,
      max: 250,
      interval: 50,
      axisLabel: {
        formatter: '{value} ml'
      }
    },
    {
      type: 'value',
      name: 'Temperature',
      min: 0,
      max: 25,
      interval: 5,
      axisLabel: {
        formatter: '{value} °C'
      }
    }
  ],
  series: [
    {
      name: 'Evaporation',
      type: 'bar',
      tooltip: {
        valueFormatter: function (value) {
          return value + ' ml';
        }
      },
      data: [
        2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3
      ]
    },
    {
      name: 'Precipitation',
      type: 'bar',
      tooltip: {
        valueFormatter: function (value) {
          return value + ' ml';
        }
      },
      data: [
        2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 182.2, 48.7, 18.8, 6.0, 2.3
      ]
    },
    {
      name: 'Temperature',
      type: 'line',
      yAxisIndex: 1,
      tooltip: {
        valueFormatter: function (value) {
          return value + ' °C';
        }
      },
      data: [2.0, 2.2, 3.3, 4.5, 6.3, 10.2, 20.3, 23.4, 23.0, 16.5, 12.0, 6.2]
    }
  ]
});

onActivated(() => {
  getdata();
  getchartdata(data_type.value, date_type.value);
})

const getchartdata = (data_type, date_type) => {
  console.log('getchartdata', data_type, date_type);
  data_loading.value = true;
  proxy.$api.doAPI("/statistics/chart", { data_type, date_type }).then((res) => {
    data_loading.value = false;
    // setTimeout(() => data_loading.value = false, 1500);
    if (res.code === 0) {
      if (data_type === 'order') {
        orderOption1.value = generateLineOption(_.map(res.data.result, n => ({ label: n.date, value: Number(n.amount) })));
        orderOption2.value = generateLineOption(_.map(res.data.result, n => ({ label: n.date, value: n.count })));
      }
      if (data_type === 'trade') {
        tradeOption1.value = generateLineOption(_.map(res.data.result, n => ({ label: n.date, value: Number(n.amount) })));
        tradeOption2.value = generateLineOption(_.map(res.data.result, n => ({ label: n.date, value: n.count })));
      }
      if (data_type === 'purchase') {
        purchaseOption1.value = generateLineOption(_.map(res.data.result, n => ({ label: n.date, value: Number(n.amount) })));
        purchaseOption2.value = generateLineOption(_.map(res.data.result, n => ({ label: n.date, value: n.count })));
      }
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    data_loading.value = false;
    // setTimeout(() => data_loading.value = false, 1500);
    console.error(err);
  });
}

const getdata = () => {
  loading.value = true;
  proxy.$api.doAPI("/statistics/total").then((res) => {
    loading.value = false;
    if (res.code === 0) {
      order_amount.value = res.data.order_amount;
      trade_amount.value = res.data.trade_amount;
      purchase_amount.value = res.data.purchase_amount;
      logistics_amount.value = res.data.logistics_amount;
      credit_amount.value = res.data.credit_amount;
      loan_paid_amount.value = res.data.loan_paid_amount;
      loan_unpaid_amount.value = res.data.loan_unpaid_amount;
      loan_verify_amount.value = res.data.loan_verify_amount;
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    loading.value = false;
    console.error(err);
  });
};
</script>
<style lang="less" scoped>
:deep(.ant-layout-header) {
  display: flex;
  padding: 0 20px;
}

:deep(.ant-table-thead > tr > th) {
  padding: 8px 8px !important;
}

:deep(.ant-card-head) {
  padding: 0;
}

p {
  margin: 0;
  padding: 0;
}
</style>